// Native American Warriors Data - Group Three (Eastern Woodland Leaders)

// Tecumseh's workout programs
const tecumsehPrograms = [
    {
        id: 'pan-indian-alliance-training',
        name: 'Pan-Indian Alliance Training',
        description: 'Unifying strength that brings together diverse tribes into one powerful force',
        pattern: 'ma@wd',
        reps: 18,
        sets: 3,
        focus: 'Tribal Unity'
    },
    {
        id: 'shawnee-warrior-conditioning',
        name: 'Shawnee Warrior Conditioning',
        description: 'Traditional woodland warrior training from the heart of Shawnee territory',
        pattern: '@wdam',
        reps: 16,
        sets: 4,
        focus: 'Woodland Mastery'
    },
    {
        id: 'great-lakes-diplomacy-workout',
        name: 'Great Lakes Diplomacy Workout',
        description: 'Charismatic leadership training for those who unite nations through words and deeds',
        pattern: 'wa@md',
        reps: 14,
        sets: 4,
        focus: 'Diplomatic Charisma'
    },
    {
        id: 'prophets-brother-protocol',
        name: 'Prophet\'s Brother Protocol',
        description: 'Spiritual warrior training guided by sacred visions and prophecy',
        pattern: 'm@wad',
        reps: 20,
        sets: 3,
        focus: 'Spiritual Guidance'
    },
    {
        id: 'confederation-leader-training',
        name: 'Confederation Leader Training',
        description: 'Multi-tribal leadership conditioning for those who command diverse alliances',
        pattern: 'adw@m',
        reps: 15,
        sets: 4,
        focus: 'Alliance Command'
    },
    {
        id: 'legendary-unifier-mastery',
        name: 'Legendary Unifier Mastery',
        description: 'Ultimate training for the greatest Native American unifier in history',
        pattern: 'ma@wd!',
        reps: 22,
        sets: 3,
        focus: 'Legendary Unity'
    }
];

// Pontiac's workout programs
const pontiacPrograms = [
    {
        id: 'siege-warfare-training',
        name: 'Siege Warfare Training',
        description: 'Patient tactical conditioning for warriors who can outlast any fortification',
        pattern: '@mwad',
        reps: 17,
        sets: 3,
        focus: 'Siege Mastery'
    },
    {
        id: 'ottawa-chief-conditioning',
        name: 'Ottawa Chief Conditioning',
        description: 'Great Lakes leadership training combining water and woodland warfare',
        pattern: 'wm@da',
        reps: 13,
        sets: 5,
        focus: 'Great Lakes Power'
    },
    {
        id: 'conspiracy-leader-workout',
        name: 'Conspiracy Leader Workout',
        description: 'Strategic coordination training for organizing widespread resistance movements',
        pattern: 'mad@w',
        reps: 19,
        sets: 3,
        focus: 'Strategic Coordination'
    },
    {
        id: 'fort-detroit-protocol',
        name: 'Fort Detroit Protocol',
        description: 'Urban warfare conditioning for assaulting heavily fortified positions',
        pattern: '@wade m',
        reps: 21,
        sets: 3,
        focus: 'Urban Assault'
    },
    {
        id: 'great-lakes-resistance-training',
        name: 'Great Lakes Resistance Training',
        description: 'Regional uprising conditioning across the vast Great Lakes territories',
        pattern: 'wa@dm',
        reps: 12,
        sets: 5,
        focus: 'Regional Uprising'
    },
    {
        id: 'siege-master-mastery',
        name: 'Siege Master Mastery',
        description: 'Complete mastery training for the greatest siege warfare tactician',
        pattern: '@mwad!',
        reps: 24,
        sets: 3,
        focus: 'Siege Excellence'
    }
];

// King Philip Metacomet's workout programs
const kingPhilipPrograms = [
    {
        id: 'wampanoag-resistance-training',
        name: 'Wampanoag Resistance Training',
        description: 'New England survival conditioning for desperate resistance against overwhelming odds',
        pattern: 'mad@w',
        reps: 16,
        sets: 4,
        focus: 'Desperate Resistance'
    },
    {
        id: 'kings-war-conditioning',
        name: 'King\'s War Conditioning',
        description: 'Total war training that burns everything to preserve freedom',
        pattern: '@wmad',
        reps: 18,
        sets: 3,
        focus: 'Total War'
    },
    {
        id: 'new-england-woodland-workout',
        name: 'New England Woodland Workout',
        description: 'Forest warfare conditioning in the dense woodlands of New England',
        pattern: 'wa@md',
        reps: 14,
        sets: 4,
        focus: 'Forest Warfare'
    },
    {
        id: 'last-stand-protocol',
        name: 'Last Stand Protocol',
        description: 'Heroic conditioning for those who choose death before surrender',
        pattern: 'mwa@d',
        reps: 22,
        sets: 3,
        focus: 'Heroic Sacrifice'
    },
    {
        id: 'sachems-legacy-training',
        name: 'Sachem\'s Legacy Training',
        description: 'Noble leadership conditioning that preserves honor even in defeat',
        pattern: 'ad@mw',
        reps: 11,
        sets: 5,
        focus: 'Noble Legacy'
    },
    {
        id: 'freedom-fighter-mastery',
        name: 'Freedom Fighter Mastery',
        description: 'Ultimate training for those who die free rather than live enslaved',
        pattern: 'mad@w!',
        reps: 20,
        sets: 3,
        focus: 'Ultimate Freedom'
    }
];

// Blue Jacket's workout programs
const blueJacketPrograms = [
    {
        id: 'shawnee-tactician-training',
        name: 'Shawnee Tactician Training',
        description: 'Advanced tactical conditioning combining traditional warfare with new strategies',
        pattern: '@wmad',
        reps: 15,
        sets: 4,
        focus: 'Tactical Innovation'
    },
    {
        id: 'ohio-valley-conditioning',
        name: 'Ohio Valley Conditioning',
        description: 'River valley warfare training in the contested Ohio territories',
        pattern: 'maw@d',
        reps: 17,
        sets: 3,
        focus: 'Valley Control'
    },
    {
        id: 'fallen-timbers-workout',
        name: 'Fallen Timbers Workout',
        description: 'Battlefield conditioning for fighting in difficult terrain and obstacles',
        pattern: 'wa@dm',
        reps: 19,
        sets: 3,
        focus: 'Obstacle Warfare'
    },
    {
        id: 'alliance-warrior-protocol',
        name: 'Alliance Warrior Protocol',
        description: 'Multi-tribal conditioning for warriors fighting in diverse confederations',
        pattern: '@madw',
        reps: 13,
        sets: 5,
        focus: 'Confederate Strength'
    },
    {
        id: 'northwestern-resistance-training',
        name: 'Northwestern Resistance Training',
        description: 'Regional defense conditioning across the vast Northwestern territories',
        pattern: 'dam@w',
        reps: 16,
        sets: 4,
        focus: 'Regional Defense'
    },
    {
        id: 'tactical-master-mastery',
        name: 'Tactical Master Mastery',
        description: 'Complete tactical mastery for one of the finest Native American strategists',
        pattern: '@wmad!',
        reps: 21,
        sets: 3,
        focus: 'Strategic Mastery'
    }
];

// Cornstalk's workout programs
const cornstalkPrograms = [
    {
        id: 'diplomat-warrior-training',
        name: 'Diplomat Warrior Training',
        description: 'Dual-path conditioning for those who must excel in both council and combat',
        pattern: 'wa@md',
        reps: 12,
        sets: 5,
        focus: 'Dual Excellence'
    },
    {
        id: 'ohio-river-conditioning',
        name: 'Ohio River Conditioning',
        description: 'River warfare training along the vital Ohio River corridor',
        pattern: 'm@wad',
        reps: 14,
        sets: 4,
        focus: 'River Mastery'
    },
    {
        id: 'peace-negotiator-workout',
        name: 'Peace Negotiator Workout',
        description: 'Diplomatic strength training for those who seek peace from positions of power',
        pattern: 'ad@wm',
        reps: 18,
        sets: 3,
        focus: 'Peaceful Power'
    },
    {
        id: 'point-pleasant-protocol',
        name: 'Point Pleasant Protocol',
        description: 'Major battle conditioning commemorating the great clash at Point Pleasant',
        pattern: '@mwad',
        reps: 20,
        sets: 3,
        focus: 'Major Battle'
    },
    {
        id: 'shawnee-elder-training',
        name: 'Shawnee Elder Training',
        description: 'Wisdom-based conditioning that combines experience with continued strength',
        pattern: 'mwa@d',
        reps: 10,
        sets: 6,
        focus: 'Elder Wisdom'
    },
    {
        id: 'noble-chief-mastery',
        name: 'Noble Chief Mastery',
        description: 'Complete mastery for a chief who chose honor in war and dignity in peace',
        pattern: 'wa@md!',
        reps: 16,
        sets: 4,
        focus: 'Noble Honor'
    }
];

// Black Hawk's workout programs
const blackHawkPrograms = [
    {
        id: 'sauk-defender-training',
        name: 'Sauk Defender Training',
        description: 'Homeland defense conditioning for warriors protecting their ancestral lands',
        pattern: 'mad@w',
        reps: 17,
        sets: 3,
        focus: 'Homeland Defense'
    },
    {
        id: 'mississippi-river-conditioning',
        name: 'Mississippi River Conditioning',
        description: 'Great river warfare training along the mighty Mississippi corridor',
        pattern: '@wmda',
        reps: 15,
        sets: 4,
        focus: 'River Warfare'
    },
    {
        id: 'black-hawk-war-workout',
        name: 'Black Hawk War Workout',
        description: 'Final resistance training for those who fight impossible odds with dignity',
        pattern: 'wa@dm',
        reps: 19,
        sets: 3,
        focus: 'Final Resistance'
    },
    {
        id: 'prairie-bluff-protocol',
        name: 'Prairie Bluff Protocol',
        description: 'High ground tactical conditioning overlooking the vast prairie lands',
        pattern: 'm@wad',
        reps: 21,
        sets: 3,
        focus: 'High Ground'
    },
    {
        id: 'defiant-spirit-training',
        name: 'Defiant Spirit Training',
        description: 'Unbreakable spirit conditioning that maintains dignity despite defeat',
        pattern: 'adm@w',
        reps: 13,
        sets: 5,
        focus: 'Defiant Dignity'
    },
    {
        id: 'proud-warrior-mastery',
        name: 'Proud Warrior Mastery',
        description: 'Ultimate training for a warrior who never lost his pride or principles',
        pattern: 'mad@w!',
        reps: 23,
        sets: 3,
        focus: 'Proud Legacy'
    }
];

// Main Native American warriors data object - Group Three
const nativeAmericanThreeTrainersData = {
    'tecumseh': {
        id: 'tecumseh',
        name: 'Tecumseh',
        specialization: 'Pan-Indian Unity & Diplomatic Warfare',
        image: '/assets/images/Tecumseh.jpg',
        experience: '43+ years',
        category: 'native-american',
        color: '#228B22',
        secondaryColor: '#C0C0C0',
        intro: `The great Shawnee leader who envisioned a united Indian confederation, Tecumseh combined charismatic diplomacy with brilliant warfare. His training develops the unifying strength needed to bring together diverse peoples and the tactical brilliance to lead them in battle. Students learn that true leadership means inspiring others to transcend their differences for a greater cause.`,
        programs: tecumsehPrograms
    },
    'pontiac': {
        id: 'pontiac',
        name: 'Pontiac',
        specialization: 'Siege Warfare & Strategic Coordination',
        image: '/assets/images/Pontiac.jpg',
        experience: '50+ years',
        category: 'native-american',
        color: '#4682B4',
        secondaryColor: '#C0C0C0',
        intro: `The Ottawa war chief who orchestrated the greatest coordinated Indian uprising in history, Pontiac mastered siege warfare and strategic coordination. His training builds the patient strength needed for long campaigns and the organizational skills to coordinate complex multi-tribal operations across vast territories.`,
        programs: pontiacPrograms
    },
    'king-philip-metacomet': {
        id: 'king-philip-metacomet',
        name: 'King Philip Metacomet',
        specialization: 'Total War & Desperate Resistance',
        image: '/assets/images/King-Philip-Metacomet.jpg',
        experience: '40+ years',
        category: 'native-american',
        color: '#8B0000',
        secondaryColor: '#C0C0C0',
        intro: `The Wampanoag sachem who led the bloodiest war in American colonial history, King Philip chose total resistance over gradual extinction. His training develops the fierce conditioning needed for desperate warfare and the noble spirit that chooses death before dishonor. Students learn that some principles are worth any sacrifice.`,
        programs: kingPhilipPrograms
    },
    'blue-jacket': {
        id: 'blue-jacket',
        name: 'Blue Jacket',
        specialization: 'Tactical Innovation & Alliance Warfare',
        image: '/assets/images/Blue-Jacket.jpg',
        experience: '55+ years',
        category: 'native-american',
        color: '#191970',
        secondaryColor: '#C0C0C0',
        intro: `The Shawnee war chief who perfected woodland tactics and led the great Northwestern confederacy, Blue Jacket combined traditional warfare with innovative strategies. His training develops adaptive tactical thinking and the versatile strength needed to fight effectively in diverse terrains and changing circumstances.`,
        programs: blueJacketPrograms
    },
    'cornstalk': {
        id: 'cornstalk',
        name: 'Cornstalk',
        specialization: 'Diplomatic Strength & Noble Warfare',
        image: '/assets/images/Cornstalk.jpg',
        experience: '60+ years',
        category: 'native-american',
        color: '#B8860B',
        secondaryColor: '#C0C0C0',
        intro: `The Shawnee chief who exemplified the warrior-diplomat ideal, Cornstalk fought fiercely in war yet sought honorable peace. His training builds the balanced strength needed for both combat excellence and diplomatic wisdom, teaching that true power includes knowing when to fight and when to seek peace.`,
        programs: cornstalkPrograms
    },
    'black-hawk': {
        id: 'black-hawk',
        name: 'Black Hawk',
        specialization: 'Homeland Defense & Proud Resistance',
        image: '/assets/images/Black-Hawk.jpg',
        experience: '71+ years',
        category: 'native-american',
        color: '#2F4F4F',
        secondaryColor: '#C0C0C0',
        intro: `The Sauk war leader who fought to defend his people's homeland along the Mississippi River, Black Hawk embodied proud resistance and unwavering dignity. His training develops the defensive strength needed to protect what matters most and the inner nobility that maintains honor even in defeat.`,
        programs: blackHawkPrograms
    }
};

// Export the data
export default nativeAmericanThreeTrainersData;